import { ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core'
import { ActivatedRoute, type Params, Router, RouterModule } from '@angular/router'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import {
  type CustomerPortalConfig, type Navigation
} from '@inside-hub-app/customer-portal-config'
import { KeycloakService } from 'keycloak-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import { type ParsedToken } from '../../../../models/keycloak'
import { DataService } from '../../../services/data.service'
import { ResizeService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { SharedService, type Tab } from '../../../services/shared.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { UserNotificationsComponent } from '../../user-details/user-notifications/user-notifications.component'
import { RevolutionGeneralUserDataComponent } from '../general-user-data/general-user-data.component'
import { RevolutionUserPersonalisationComponent } from '../general-user-data/user-personalisation/user-personalisation.component'
import { PrivacyComponent } from '../general-user-data/privacy/privacy.component'
import { gdprComponent } from '../general-user-data/gdpr/gdpr.component'
@Component({
  selector: 'customer-portal-app-revolution-my-account-view',
  standalone: true,
  templateUrl: './my-account-view.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    UserNotificationsComponent,
    RevolutionGeneralUserDataComponent,
    RevolutionUserPersonalisationComponent,
    PrivacyComponent,
    gdprComponent
  ]
})
export class MyAccountViewComponent implements OnInit, OnDestroy {
  error = false
  token: ParsedToken
  user: User
  public country: string

  currentTabName: Tab
  urlParams: Params

  sub = {
    onResizePx: null
  }

  public screenSizePx: number
  showMobileView: boolean
  hasNotifications
  swipeData = {
    currentTab: null,
    swipeCoord: null,
    swipeTime: null,
    tabsCount: null
  }

  tabs = {
    0: 'personal-data',
    1: 'dataprotection',
    2: 'user-personalization',
    3: 'user-notifications'
  }

  navigationItems
  hasNewGDPR
  constructor (
    private readonly keycloak: KeycloakService,
    private readonly route: ActivatedRoute,
    private readonly logger: NGXLogger,
    private readonly dataService: DataService,
    public resizeService: ResizeService,
    public sharedService: SharedService,
    private readonly cdf: ChangeDetectorRef,
    private readonly router: Router,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.navigationItems =
    this.remoteConfigService.getArrayValues<Navigation[]>('navigationAccount')
    this.hasNewGDPR = this.remoteConfigService.get('hasNewGDPR')

    route.params.subscribe(params => {
      this.urlParams = params
      this.switchRoute(this.urlParams)
    })
  }

  scrollToTop (): void {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    })
    this.logger.debug('Scrolled to top')
  }

  ngOnInit (): void {
    this.token = this.keycloak.getKeycloakInstance().tokenParsed as ParsedToken
    this.country = this.remoteConfigService.get('country.code')

    this.dataService.onUserLoaded.subscribe(user => {
      this.user = user != null ? user : null
    })

    this.sub.onResizePx = this.resizeService.onResizePx.subscribe(size => {
      this.screenSizePx = size
      this.isMobileView()
    })

    this.screenSizePx = this.resizeService.screenSizePx
    this.isMobileView()
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }

  isMobileView (): void {
    if (this.screenSizePx > 0) {
      if (this.screenSizePx < 1024) {
        this.showMobileView = true
        this.setMobileTabs()
      } else {
        this.showMobileView = false
      }
      this.cdf.detectChanges()
    }
  }

  switchRoute (urlParams: Params): void {
    if (urlParams.detailsSubmenu != null) {
      const param = this.urlParams.detailsSubmenu

      switch (param) {
        case 'user-personalization':
          this.currentTabName = 'myAccountUserPersonalization'
          this.swipeData.currentTab = 2
          break
        case 'dataprotection':
          this.currentTabName = 'myAccountDataProtection'
          this.swipeData.currentTab = 1
          break
        case 'user-notifications':
          this.currentTabName = 'myAccountUserNotifications'
          this.swipeData.currentTab = 3
          break
        default:
          // this.scrollToTop()
          this.currentTabName = 'myAccountPersonalData'
          this.swipeData.currentTab = 0
      }
    } else {
      this.scrollToTop()
      this.currentTabName = 'myAccountPersonalData'
      this.swipeData.currentTab = 0
    }
  }

  setMobileTabs (): void {
    const tabsLength = this.navigationItems.length
    const tabValues = this.navigationItems
    this.swipeData.tabsCount = tabsLength
    if (
      tabValues.find(el => {
        return el.path === '/user/user-notifications'
      }) != null
    ) {
      this.hasNotifications = true
    } else {
      this.hasNotifications = false
    }
  }

  swipe (e: TouchEvent, when: string): void {
    const currTab = this.swipeData.currentTab
    this.sharedService.tabSwipe(e, when, this.swipeData)
    if (currTab !== this.swipeData.currentTab) {
      // change route
      const tab = this.tabs[this.swipeData.currentTab]
      void this.router.navigate(['/user', tab])
    }
  }
}
